/**
 * Create formatted date and time string from timestamp
 * By default, date and short time should render "Jan 1, 1990, 12:00 AM" in "en" locale
 */
const formatDate = (
  timestamp: string | undefined | null,
  options: Intl.DateTimeFormatOptions = {
    dateStyle: "medium",
    timeStyle: "short",
  },
  defaultText = "Never"
) => {
  if (!timestamp) return defaultText;

  try {
    const date = new Date(timestamp);
    // Passing an empty array as locales param uses browser's default locale
    return new Intl.DateTimeFormat([], options).format(date);
  } catch {
    return "None";
  }
};

export { formatDate };
